import { api } from '../client'
import { ENDPOINTS } from '../config'

export interface TeacherRecord {
    _id: string
    userId?: string | null
    status?: string
    branchId?: string | null
    firstName?: string | null
    lastName?: string | null
    picture?: string | null
    branch?: { _id: string; name: string } | null
    /** True for admin teachers (`teachers.isAdmin` on the backend entity). */
    isAdmin?: boolean
    // `GET /teachers` bulk-enriches these from public.users via a SQL join, so
    // they are present on list rows — but still optional, since the join misses
    // any teacher whose userId has no matching user row.
    email?: string | null
    phoneNumber?: string | null
    approvedBy?: string | null
    approvedAt?: string | null
    createdAt?: string | null
    updatedAt?: string | null
}

export interface TeacherListResponse {
    data: TeacherRecord[]
    total: number
    page: number
    limit: number
}

export const TeachersService = {
    list: (params: { status?: string; page?: number; limit?: number } = {}) =>
        api.get<TeacherListResponse>(ENDPOINTS.TEACHERS.LIST(params)),

    pending: () =>
        api.get<TeacherListResponse>(
            ENDPOINTS.TEACHERS.LIST({ status: 'pending', limit: 1000 })
        ),

    me: () => api.get<TeacherRecord>(ENDPOINTS.TEACHERS.ME),

    approve: (id: string) => api.post<unknown>(ENDPOINTS.TEACHERS.APPROVE(id)),

    reject: (id: string) => api.post<unknown>(ENDPOINTS.TEACHERS.REJECT(id)),

    suspend: (id: string) => api.post<unknown>(ENDPOINTS.TEACHERS.SUSPEND(id))
}
